// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"theme_sectionTitle__k_Z27","page":"style_page__G2cMa theme_page__1oxFh","mainTitle":"style_mainTitle__1oXc2 theme_sectionTitle__k_Z27"};